import React from 'react';
import PrivateRoute from './PrivateRoute';
import DashBoardLayout from '../components/DashBoardLayout';
import Cards from '../pages/Cards';
import Departments from '../pages/Departments';
import CardsOrder from '../pages/CardsOrder';
import TarifasPorLinha from '../pages/TarifasPorLinha';
import RelatoriosAgendados from '../pages/RelatoriosAgendados';
import Funcionarios from '../pages/Funcionarios';
import EmployeeView from '../pages/Funcionarios/Components/EmployeeView';
import EditEmployee from '../pages/Funcionarios/Components/EditEmployee';
import AddEmployee from '../pages/Funcionarios/Components/AddEmployee';
import RechargeOrders from '../pages/RechargeOrders';
import RechargeOrderDetail from '../pages/RechargeOrderDetail';
import BloquedNotDuplicated from '../pages/BloquedNotDuplicated';
import CardTicketReplaced from '../pages/CardTicketReplaced';
import NoOrders from '../pages/NoOrders';
import CardsDetail from '../pages/CardsDetail';
import MeuPerfil from '../pages/MeuPerfil';
import CardOrderDetail from '../pages/CardOrderDetail';
import Suporte from '../pages/Suporte';
import Manual from '../pages/Manual';

const DashBoardRoutes: React.FC = () => {
  return (
    <DashBoardLayout>
      <PrivateRoute path="/departamentos" exact component={Departments} />
      <PrivateRoute path="/cartoes" exact component={Cards} />
      <PrivateRoute path="/pedidos-de-cartao" exact component={CardsOrder} />
      <PrivateRoute
        path="/pedidos-de-cartao/:id"
        exact
        component={CardOrderDetail}
      />
      <PrivateRoute path="/tarifas-linha" exact component={TarifasPorLinha} />
      <PrivateRoute path="/agendado" exact component={RelatoriosAgendados} />
      <PrivateRoute
        path="/cartoes-sempedido-90dias"
        exact
        component={NoOrders}
      />
      <PrivateRoute
        path="/cartoes-bloqueados-sem-2via"
        exact
        component={BloquedNotDuplicated}
      />
      <PrivateRoute path="/funcionarios" exact component={Funcionarios} />
      <PrivateRoute path="/funcionarios/:id" exact component={EmployeeView} />
      <PrivateRoute
        path="/funcionarios/:id/editar"
        exact
        component={EditEmployee}
      />
      <PrivateRoute path="/funcionario/novo" exact component={AddEmployee} />
      <PrivateRoute
        path="/cartoes-substituidos"
        exact
        component={CardTicketReplaced}
      />
      <PrivateRoute
        path="/pedidos-de-recarga"
        exact
        component={RechargeOrders}
      />
      <PrivateRoute
        path="/pedidos-de-recarga/:CodigoPedido/"
        exact
        component={RechargeOrderDetail}
      />
      <PrivateRoute
        path="/cartoes/:CrtCodIdentifExt/"
        exact
        component={CardsDetail}
      />
      <PrivateRoute path="/meu-perfil" exact component={MeuPerfil} />
      <PrivateRoute path="/suporte" exact component={Suporte} />
      <PrivateRoute path="/manual/" exact component={Manual} />
    </DashBoardLayout>
  );
};

export default DashBoardRoutes;
